import Queue from "./Queue";
const HistoryQueue = Queue();

function guid() {
  let S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return S4() + S4();
}
export const load = (items) => {
  HistoryQueue.setQueue(items || []);
};

export const removeItem = (item) => {
  let items = HistoryQueue.getQueue();
  let historyItems = [...items];
  const ind = historyItems.findIndex((hist_item) => hist_item.id === item.id);
  historyItems.splice(ind, 1);
  localStorage.setItem(btoa("searchhistory"), JSON.stringify(historyItems));
  return historyItems;
};

export const getHistory = () => {
  try {
    let queueItems = localStorage.getItem(btoa("searchhistory"));

    queueItems = JSON.parse(queueItems || []);
    HistoryQueue.setQueue(queueItems);
    return queueItems.reverse();
  } catch (err) {
    console.log("Queue Error", err);
    return [];
  }
};

export const addToHistory = (item) => {
  HistoryQueue.enqueue({ id: guid(), ...item });
  let queueData = [...HistoryQueue.getQueue()];
  localStorage.setItem(btoa("searchhistory"), JSON.stringify(queueData));
  return queueData.reverse();
};
